import React from "react";
import InsuranceCertificateAddition from "./InsuranceCertificateAddition";

const InsuranceCertificates = (props) => {
  return (
    <>
      {props.panel && (
        <>
          <div
            id={"insurance_certificates-panel-" + props.insurance.id}
            className="inb-c-item-details inb-c-order-reservations row"
          >
            <InsuranceCertificateAddition
              certificates={props.insurance.insurance_certificates}
              id={props.insurance.id}
              insurance={props.insurance}
              dispatch={props.data.dispatch}
            />
          </div>
        </>
      )}
      {!props.panel && (
        <InsuranceCertificateAddition
          certificates={props.insurance.insurance_certificates}
          id={props.insurance.id}
          insurance={props.insurance}
          dispatch={props.data.dispatch}
        />
      )}
    </>
  );
};

export default InsuranceCertificates;
